// extracted by mini-css-extract-plugin
export var skipLink = "gx_x9";